import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Button from '../../buttons/Button';

import styles from '../../../../styles/items/games/nhl.module.scss';

interface NhlGameItemProps {
    game: NhlGame;
    participation: Participation;
    canParticipate?: boolean;
    className?: string | null;
}

function NhlGameItem({
    game,
    participation,
    canParticipate = true,
    className = null,
}: NhlGameItemProps) {
    const themeClassName = useThemeClassName(styles);
    const { sportGame, url } = game || {};
    const { teamAway, teamHome, startAt, ended } = sportGame || {};
    const { name: teamAwayName = null, location: teamAwayLocation = null } = teamAway || {};
    const { name: teamHomeName, location: teamHomeLocation = null } = teamHome || {};
    const startAtDate = useMemo(() => parseISO(startAt), [startAt]);

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.active]: participation !== null,
                    [styles.canParticipate]: canParticipate,
                    [styles.ended]: ended,
                },
                themeClassName,
                className,
            ])}
            href={canParticipate ? url : null}
            disabled={!canParticipate}
        >
            <span className={styles.content}>
                <h2 className={styles.label}>
                    <span className={styles.teamAway}>
                        <span className={styles.name}>{teamAwayLocation || teamAwayName}</span>
                    </span>
                    <span className={styles.vs}>
                        <FormattedMessage defaultMessage="VS" description="NHL versus label" />
                    </span>
                    <span className={styles.teamHome}>
                        <span className={styles.name}>{teamHomeLocation || teamHomeName}</span>
                    </span>
                </h2>
                <span className={styles.startAt}>
                    <FormattedDate value={startAtDate} hour="numeric" minute="numeric" />
                </span>
                <span className={styles.chevron}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </span>
            </span>
            <span
                className={classNames([
                    styles.content,
                    {
                        [styles.ended]: false,
                    },
                ])}
            >
                {ended ? (
                    <span className={styles.endedLabel}>
                        <FormattedMessage defaultMessage="Game played" description="Game played" />
                    </span>
                ) : null}
            </span>
        </Button>
    );
}

export default NhlGameItem;
